module.exports = __webpack_public_path__ + "img/pic7.69d808f1.png";